import type { HasJobId } from "./HasJobId.type"
import type { JobResultDataUnion } from "./JobDataUnion.type"

export type WebWorkerJobListItem<T> = HasJobId & {
  resolve: (value: T | PromiseLike<T>) => void,
  reject: (reason?: unknown) => void,
}

const data = new WeakMap<Worker, Array<WebWorkerJobListItem<JobResultDataUnion>>>()

export default function getWebWorkerJobsList<T extends JobResultDataUnion>(
  worker: Worker
): Array<WebWorkerJobListItem<T>> {
  let jobsList = data.get(worker)
  if (!jobsList) {
    jobsList = []
    data.set(worker, jobsList)
  }
  return jobsList
}